
export const V_FORM_ENUM = {
  container: 1, // 容器组件
  basic: 2, // 基础组件
  advanced: 3, // 高级组件
  custom: 4, // 自定义
  design: 'design',
  preview: 'preview',
  runtime: 'runtime',
  // 状态 - vform表单处理
  create: -1, // 未发起
  pending: 0, // 已经发起 - 未结束
  fulfilled: 1, // 已结束 - 成功
  rejected: 2 // 已结束 - 失败
};
